export default __webpack_public_path__ + "static/media/carousel-1.83e1fd35.png";